module.exports = __webpack_public_path__ + "static/media/memberBulkRemovedIcon.a04de2be.png";